<script lang="ts">
    let className = ''
    export { className as class }
</script>

<div class="z-container-row {className}">
    <slot></slot>
</div>

<style>
    /* A regra existia no z-container.svelte, mas o elemento é desenhado AQUI: o escopo do Svelte
       nunca a aplicava, e a linha acabava como um item de grid de uma coluna só — o conteúdo
       transbordava e os botões se sobrepunham. Ocupar as 12 colunas é o que a linha sempre quis. */
    .z-container-row {
        grid-column: 1 / -1;
        display: flex;
        align-items: center;
        width: 100%;
    }
</style>
